// dev/app-skeleton/src/lib/db.ts
// 本地数据库（Dexie）。
// PRD v1.1 决策 ②：drafts 表加密落 IDB。
// D14-DEV-v2（SEC C' 修）：移除 LocalEntry.plaintext_json 字段（明文不落本地 IDB）；
//   读路径走 entry-cache.ts 内存 LRU，lock() 即清；版本升 v3 + 迁移把旧行的 plaintext_json 抹零。
import Dexie from "dexie";
class DiaryDB extends Dexie {
    entries;
    media;
    ops;
    drafts;
    revert_snapshots;
    kv;
    constructor() {
        super("diary-db-v1");
        this.version(1).stores({
            entries: "id, updated_at, dirty, deleted",
            media: "id, kind, created_at",
            ops: "op_local_id, status, entity_id",
            drafts: "entry_id, updated_at",
            kv: "key",
        });
        // v2: PRD v1.1 ⑥ — 24h 撤销快照
        this.version(2).stores({
            revert_snapshots: "snapshot_id, user_id, expires_at, created_at",
        });
        // v3: D14-DEV-v2 / SEC C' — 删 entries.plaintext_json 字段；旧行 upgrade 时清零
        // schema 索引列只列 id + updated_at + dirty + deleted，plaintext_json 从未作为索引，
        // 故 stores() 字符串无需变更；upgrade 显式 delete 该 key 防 IDB 里残留明文。
        this.version(3).stores({
            entries: "id, updated_at, dirty, deleted",
        }).upgrade(async (tx) => {
            await tx.table("entries").toCollection().modify((row) => {
                // 老行可能有 plaintext_json；新版无该字段。直接 delete 抹零。
                if ("plaintext_json" in row)
                    delete row.plaintext_json;
            });
        });
    }
}
export const db = new DiaryDB();
/** KV helpers（本地配置 / fingerprint / last_server_version）。 */
export async function kvGet(key) {
    const row = await db.kv.get(key);
    return row?.value;
}
export async function kvSet(key, value) {
    await db.kv.put({ key, value });
}
